import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProjectsHeader.scss';

const ProjectsHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="header-container">
      <div className="filter-indicator">
        <div className="title-projects">{t('following_projects_title')}</div>
      </div>
    </div>
  );
};

export default ProjectsHeader;
